import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COMMUNITY_FIND_PROCESSOR_PATH } from '../../community/constants/communityRoutes';

/**
 * Finish-sheet actions after a hunt is in the books.
 * Harvest sits get a Find a Processor link; check-in / reminder comes later.
 */
export function HuntLoggedDoneActions({
  harvested = false,
  closeLabel,
  closeTestId,
  onClose,
}) {
  const navigate = useNavigate();

  const handleNeedProcessor = () => {
    onClose();
    navigate(COMMUNITY_FIND_PROCESSOR_PATH);
  };

  return (
    <div className="stand-tagin-sheet__actions">
      {harvested ? (
        <button
          type="button"
          className="stand-tagin-sheet__cta is-ready"
          onClick={handleNeedProcessor}
          data-testid="hunt-done-need-processor"
        >
          Need a processor?
        </button>
      ) : null}
      <button
        type="button"
        className="stand-tagin-sheet__cta is-ready is-loden"
        onClick={onClose}
        data-testid={closeTestId}
      >
        {closeLabel}
      </button>
    </div>
  );
}
